export default [
    { value: true, text: "Ligado", variante: "success" },
    { value: false, text: "Desligado", variante: "danger" },
]